/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Declinedeal_Errormessage3Inputs */

const en_coinvestments_declinedeal_errormessage3 = /** @type {(inputs: Coinvestments_Declinedeal_Errormessage3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to decline opportunity. Please try again.`)
};

/**
* | output |
* | --- |
* | "Failed to decline opportunity. Please try again." |
*
* @param {Coinvestments_Declinedeal_Errormessage3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_declinedeal_errormessage3 = /** @type {((inputs?: Coinvestments_Declinedeal_Errormessage3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Declinedeal_Errormessage3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_declinedeal_errormessage3(inputs)
});
export { coinvestments_declinedeal_errormessage3 as "coInvestments_declineDeal_errorMessage" }